import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MyOverlayRef } from '../../services/overlay/myoverlay-ref';
import { EntitySummaryComponent } from '../entity-summary.component';

@Component({
    selector: 'app-entity-summary-overlay-container',
    standalone : true,
    imports: [EntitySummaryComponent],
    templateUrl: './entity-summary-overlay-container.component.html',
    styleUrls: ['./entity-summary-overlay-container.component.scss'],
})
export class EntitySummaryOverlayContainerComponent {
  public entityObject: string | undefined; //entity object JSON string
  public entityDefinition: any;
  public summaryTitle: string = '';
  public summaryErrorText: string = '';
  public displaySidenavSvg: boolean = true;
  public displayWithRoundContainer: boolean = false;

  constructor(private ref: MyOverlayRef) {
    console.log(ref);
    if ((this.ref.data.error == '' || this.ref.data.error == undefined) && this.ref.data.jsonSummary != undefined) {
      this.entityObject = this.ref.data.jsonSummary;
      this.entityDefinition = this.ref.data.entityDefinition;
      this.summaryTitle = this.ref.data.summaryTitle;
      this.summaryErrorText = '';
    } else this.summaryErrorText = "Impossible d'afficher le résumé";
  }
}
